export enum OrganizationStatus{
    Unspecified = 0,
    Active = 1,
    PendingReview,
    Closed,
    Void
}